const Factory = ({ factoryId, onChange, company, factories, label, name, required, className, disabled, enableAllOption }) => {
  return (
    <select
      required={required ? true : false}
      disabled={disabled || company === ''}
      name={name}
      value={factoryId}
      onChange={onChange}
      aria-label="Floating label select example"
      className={`form-select ${className}`}
    >
      <option value="">Select {label}</option>
      {enableAllOption && <option value="all">All</option>}
      {factories.map((item, index) => (
        <option key={`${item.id}-${index}`} value={item.id}>
          {item?.name}
        </option>
      ))}
    </select>
  );
};

Factory.defaultProps = {
  enableAllOption: false,
};

export default Factory;
